import { useEffect, useMemo, useState } from "react";

import {
  Button,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";

// assets
import { TableSimple } from "components";
import { PageTitle } from "pages/common";
import { fournisseurService } from "services";

import { FournisseurResource } from "types/stock.type";
import { useModal } from "hooks";
import { addOrUpdateElement } from "utils/helpers";
import { EditTwoTone } from "@ant-design/icons";
import { FournisseurModal } from "./FournisseurModal";

const ListFournisseur = () => {
  const theme = useTheme();
  const [defaultValues, setDefaultValues] = useState<any | undefined>();
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<FournisseurResource[]>([]);
  const modal = useModal();

  useEffect(() => {
    setLoading(true);

    fournisseurService
      .findAll()
      .then((resultat) => {
        setData(resultat.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const save = (data: any) => {
    const body = { ...data };
    if (defaultValues?.id) {
      return fournisseurService.update(defaultValues.id, body);
    }
    return fournisseurService.create(body);
  };

  const onEdit = (original: FournisseurResource) => {
    setDefaultValues({
      id: original.id,
      nom: original.nom,
      code: original.code,
      telephone: original.telephone,
      email: original.email,
      adresse: original.adresse,
    });
    modal.show();
  };

  const closeModal = () => {
    modal.close();
    setDefaultValues(undefined);
  };

  const onFinished = (element: FournisseurResource) => {
    const index = data.findIndex(({ id }) => id === element.id);
    setData((d) => addOrUpdateElement(d, element, index));
    closeModal();
  };

  const columns = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "nom",
        Cell: ({ row: { original } }: any) => (
          <Typography variant="subtitle1">{original.nom}</Typography>
        ),
      },
      {
        Header: "Code",
        accessor: "code",
        Cell: ({ row: { original } }: any) => (
          <Typography>{original.code || "-"}</Typography>
        ),
      },
      {
        Header: "Téléphone",
        accessor: "telephone",
        Cell: ({ row: { original } }: any) => (
          <Typography>{original.telephone || "-"}</Typography>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row: { original } }: any) => (
          <Typography>{original.email || "-"}</Typography>
        ),
      },
      {
        Header: "Actions",
        accessor: "actions",

        Cell: ({ row: { original } }: any) => (
          <Tooltip title="Modifier la fonction">
            <IconButton
              color="error"
              size="large"
              onClick={() => onEdit(original)}
            >
              <EditTwoTone twoToneColor={theme.palette.error.main} />
            </IconButton>
          </Tooltip>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <PageTitle
        title="Fournisseurs"
        subtitle="Consulter et gérer les fournisseur"
        sx={{ padding: "1.5rem 0" }}
        right={
          <Button variant="contained" onClick={modal.show}>
            Créer un fournisseur
          </Button>
        }
      />

      <TableSimple
        columns={columns}
        data={data}
        withPagination
        loading={loading}
      />
      {modal.open && (
        <FournisseurModal
          onBack={closeModal}
          onFinished={onFinished}
          onSave={save}
          defaultValues={defaultValues}
        />
      )}
    </>
  );
};

export default ListFournisseur;
